<template>
  <v-layout column>
    <v-flex xs11 offset-xs0>
      <panel title="Editor Reports">
        <div slot="top">
          <v-layout row wrap v-if ='$store.state.isEditor'>
            <v-flex>
              <v-layout row >
                <v-flex xs1 mt-4><B class='text-left title'>2</B></v-flex>
                <v-flex  xs6 mt-4 style='text-align:left'><B class='title'>Army people with a digitised NAA recorded</B></v-flex>
                <v-flex ml-3 xs2><v-text-field v-model='surname' label='Surname starting with...' v-on:keyup.enter='runArmyNAA'/></v-flex>
                <v-flex xs2 mt-2><v-btn @click="runArmyNAA()">Run</v-btn></v-flex>
              </v-layout>               
              <v-layout row  >
                <v-flex xs1 mt-4><B class='text-left title'>1</B></v-flex>
                <v-flex  xs6 mt-4 style='text-align:left'><B class='title'>Army people with no hair colour recorded but with a digitised NAA recorded</B></v-flex>
                <v-flex ml-3 xs2><v-text-field v-model='surname' label='Surname starting with...' v-on:keyup.enter='runNoHairNAA'/></v-flex>
                <v-flex xs2 mt-2><v-btn @click="runNoHairNAA()">Run</v-btn></v-flex>
              </v-layout>
             
            </v-flex>
          </v-layout>
        </div>         
      </panel>            
    </v-flex>
  </v-layout>
</template>
<script>

import Panel from "@/components/Panel" ;

export default {
  components: { Panel },
  data () {
    return {
      surname: ''
    };
  },
  methods: {

    async runNoHairNAA () {  
      const route = {
        name: "editorReportsPeople",
        query: {
          reportName: "reportForEditorsDigitRecordNoHair",
          description: "Army people with no hair colour recorded but with a digitised NAA recorded",
          surname: ""
        }
      }
      if (this.surname.length > 0) route.query.surname = this.surname ;
      console.log("PUSHING ROUTE " + JSON.stringify(route)) ;
      this.$router.push(route) ;
    },

    async runArmyNAA () {  
      const route = {
        name: "editorReportsPeople",
        query: {
          reportName: "reportForEditorsDigitRecordArmy",
          description: "Army people with a digitised NAA recorded",
          surname: ""
        }
      }
      if (this.surname.length > 0) route.query.surname = this.surname ;
      console.log("PUSHING ROUTE " + JSON.stringify(route)) ;
      this.$router.push(route) ;
    }    
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/EditorReports.vue